<template>
  <v-dialog
    v-model="showModal"
    max-width="1000"
    persistent
  >
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <validation-observer ref="validator" v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới nguồn khách hàng
          </template>
          <template v-else>
            Cập nhật nguồn khách hàng
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required|max:255"
                name="Nguồn khách hàng"
              >
                <v-text-field
                  v-model="contact.name"
                  label="Nguồn khách hàng *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                :rules="{ required: true, max:255, regex: regex.isUsername }"
                name="Mã"
              >
                <v-text-field
                  v-model="contact.code"
                  label="Mã *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Trạng thái"
              >
                <v-autocomplete
                  v-model="contact.status"
                  :items="contactSourceStatusOptions"
                  :error-messages="errors"
                  item-text="text"
                  item-value="value"
                  label="Trạng thái *"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <validation-provider
                class="mb-2"
                name="Mô tả"
                rules="max:255"
                v-slot="{ errors }"
              >
                <v-textarea
                  v-model="contact.description"
                  label="Mô tả"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(saveContact)"
          >
            Lưu lại
          </v-btn>

          <v-btn
            class="ml-0"
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { contactSourceStatusOptions,regex } from '../../../helpers/constants'
  const ContactSourceRepository = RepositoryFactory.get('contact_source')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    data () {
      return {
        showModal: false,
        isCreate: true,
        errorMessage: '',
        contact: {},
        contactSourceStatusOptions,
        regex,
      }
    },
    created () {
      Bus.$on('show-contact-form-modal', (contact) => {
        this.showModal = true
        if (contact.id) this.isCreate = false
        else this.isCreate = true
        this.contact = _.cloneDeep(contact)

      })
    },
    methods: {
      hideModal: function () {
        this.showModal = false
        this.errorMessage = ''
        this.$refs.validator.reset()
      },
      async saveContact () {
        const contactData = {
          name: _.trim(this.contact.name),
          description: _.trim(this.contact.description),
          code: this.contact.code,
          status: this.contact.status,
        }
        let response = {}
        const loader = this.$loading.show()
        if (this.isCreate) {
          response = await ContactSourceRepository.create(contactData)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
                      title: 'Thêm nguồn khách hàng thành công',
                      confirmButtonText: 'Đồng ý',
                    },
            ).then(() => {
              Bus.$emit('contact-source-list-reload')
            })
          }
        } else {
          const contactData = {
            name: _.trim(this.contact.name),
            description: _.trim(this.contact.description),
            code: this.contact.code,
            status: this.contact.status,
          }
          response = await ContactSourceRepository.update(this.contact.id, contactData)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
                      title: 'Cập nhật nguồn khách hàng thành công',
                      confirmButtonText: 'Đồng ý',
                    },
            ).then(() => {
              Bus.$emit('contact-source-list-reload')
            })
          }
        }
        loader.hide()
      },
    },
  }
</script>
